// extracted by mini-css-extract-plugin
export var borderRadius = "_el-4";
export var large = "_el-3";
export var logoContainer = "_el-0";
export var nameLogo = "_el-2";
export var small = "_el-1";